jQuery(function($) {

	// ローディングアニメーション
	$(window).on('load',function(){
		if ($('body').hasClass('home')) {
			$('.loader').delay(1500).fadeOut('slow');
			$('.loader_logo').delay(1200).fadeOut('slow');
			setTimeout(function() {
				$('.mv_bird').addClass('is-fly');
				setTimeout(function() {
					$('.page-top').addClass('is-show is-wait');
					$('.mv_logo').addClass('is-show');
				}, 3500)
			}, 2000)
		}
	});

	$(window).on('load resize', function() {
		// トップページ メインビジュアル位置調整
		if ($('body').hasClass('home') || $('body').hasClass('recruit')) {
			const headerHeight = $('.header').outerHeight();
			$('.header').css('margin-bottom', -headerHeight);
		}
	});

	let state = false;
	let scrollPos;

	// ヘッダー追従
	const $cloneHeader = $('header').clone().addClass('clone-header').appendTo('body');
	const showClass = 'is-show';
	$(window).on('scroll load', function() {
		scrollPos = $(window).scrollTop();
		let targetH;
		if ($('body').hasClass('home')) {
			targetH = $('.header').outerHeight() + $('.mv').outerHeight();
		} else if ($('body').hasClass('recruit')) {
			targetH = $('.header').outerHeight() + $('.recruit-mv').outerHeight();
		} else {
			targetH = $('.header').outerHeight();
		}
		if (scrollPos > targetH) {
			$cloneHeader.addClass(showClass);
		} else if ($('body').hasClass('is-open')) {
			$cloneHeader.addClass(showClass);
		} else {
			$cloneHeader.removeClass(showClass);
		}
	});

	// ヘッダー ドロワーメニュー
	$('.header:not(.clone-header) .header_toggle-button').on('click', function() {
		$('body').toggleClass('is-open');
	});
	$('.body.is-open header_nav a').on('click', function() {
		$('body').removeClass('is-open');
	});

	$('.clone-header .header_toggle-button').on('click', function() {
		if (state == false) {
			let scrollPos = $(window).scrollTop();
			$('body').addClass('is-open header-fixed').css({'top': -scrollPos});
			state = true;
		} else if (state == true) {
			$('body').removeClass('is-open header-fixed').css({'top': 0});
			window.scrollTo(0, scrollPos);
			state = false;
		}
	});

	// 画面幅をリサイズした時、1024px以上ならドロワーメニューを閉じる
	$(window).on('resize', function() {
		if (window.matchMedia( '(min-width: 1024px)' ).matches && $('body').hasClass('is-open')) {
			$('body').removeClass('is-open header-fixed').css({'top': 0});
			window.scrollTo(0, scrollPos);
			state = false;
		}
	});

	// スクロール時 処理
	$(window).on('scroll resize load', function() {
		fixedPanelAnime();
		pinDownAnime();
		pageTopPosition();
		messageAnime();
	});

	// トップページ GREETING もっと読むボタン
	const $targetText = $('.section_greeting_text_second-part');
	$('.section_greeting_button').on('click', function() {
		$(this).toggleClass('is-active');
		if ($targetText.hasClass('is-close')) {
			$targetText.removeClass('is-close').addClass('is-open');
		} else {
			$targetText.removeClass('is-open').addClass('is-close');
		}
		if ($(this).hasClass('is-active')) {
			$(this).text('閉じる');
		} else {
			$(this).text('もっと読む');
		}
	});

	// フッターパネルアニメーション
	function fixedPanelAnime() {
		const $panel = $('.fixed-panel');
		const scrollTop = $(window).scrollTop();
		if (scrollTop > 500) {
			$panel.removeClass('is_down_move');
			$panel.addClass('is_up_move');
		} else {
			if ($panel.hasClass('is_up_move')) {
				$panel.removeClass('is_up_move');
				$panel.addClass('is_down_move');
			}
		}
	}

	// トップへ戻る 位置調整
	function pageTopPosition() {
		const scrollTop = $(window).scrollTop();
		const windowWidth = $(window).width();
		const windowHeight = $(window).innerHeight();
		const footerPos =  $('.footer').offset().top;
		const pageTopHeight = $('.page-top').innerHeight();
		if (windowWidth <= 767) {
			if (scrollTop + windowHeight >= (footerPos + pageTopHeight + 100)) {
				let pos = (scrollTop + windowHeight) - footerPos - pageTopHeight - 18.5;
				$('.page-top').css('bottom', pos);
			} else {
					$('.page-top').css('bottom','7rem');
			}
		} else {
			if (scrollTop + windowHeight >= (footerPos + pageTopHeight + 65)) {
				let pos = (scrollTop + windowHeight) - footerPos - pageTopHeight - 33;
				$('.page-top').css('bottom', pos);
			} else {
					$('.page-top').css('bottom','3%');
			}
		}
	}

	// トップへ戻る スクロールアニメーション
	let before = $(window).scrollTop();
	let pageTop_setTime;
	$(window).on('scroll', function() {
		let after = $(window).scrollTop();
		if (before > after + 3) {
			$('.page-top').removeClass('is-wait');
			$('.page-top').removeClass('is-down');
			$('.page-top').addClass('is-up');
			clearTimeout(pageTop_setTime);
			pageTop_setTime = setTimeout(function(){
					$('.page-top').removeClass('is-up');
					$('.page-top').addClass('is-wait');
			},300);
		} else if (before + 3 < after) {
			$('.page-top').removeClass('is-wait');
			$('.page-top').removeClass('is-up');
			$('.page-top').addClass('is-down');
			clearTimeout(pageTop_setTime);
			pageTop_setTime = setTimeout(function(){
					$('.page-top').removeClass('is-down');
					$('.page-top').addClass('is-wait');
			},300);
		}
		before = after;
	});

	// トップへ戻る クリック処理
	$('.page-top').on('click', function() {
		$('body,html').animate({
			scrollTop: 0
		}, 500, 'swing');
	});

	// トップページ WORKS ピンアニメーション
	function pinDownAnime() {
		$('.section_works_pin-item').each(function() {
			const scrollTop = $(window).scrollTop();
			const windowWidth = $(window).width();
			const windowHeight = $(window).innerHeight();
			let targetPos;
			if (windowWidth <= 767) {
				targetPos = $(this).offset().top + 200;
			} else {
				targetPos = $(this).offset().top + 500;
			}
			if (scrollTop >= targetPos - windowHeight) {
				$(this).addClass('is-move');
			} 
		});
	}

	// 元請業者様へ 「お言葉」アニメーション
	function messageAnime() {
		$('.partner-message_item').each(function() {
			const scrollTop = $(window).scrollTop();
			const windowWidth = $(window).width();
			const windowHeight = $(window).innerHeight();
			let targetPos;
			if (windowWidth <= 767) {
				targetPos = $(this).offset().top + 100;
			} else {
				targetPos = $(this).offset().top + 300;
			}
			if (scrollTop >= targetPos - windowHeight) {
				$(this).addClass('is-move');
			} 
		});
	}

	// ページ内リンク スムーススクロール
	const $scroll_link = $('.js_scroll_link');
	const headerHeight = $('.clone-header').outerHeight();
	const speed = 500;
	$scroll_link.on('click', function() {
		const elmHash = $(this).attr('href');
		const position = $(elmHash).offset().top - headerHeight;
		$('html, body').animate({scrollTop: position}, speed, 'swing');
		return false;
	});

	// ページ外リンク アンカー位置調整
	$(window).on('load',function(){
		const urlHash = location.hash;
		if (urlHash) {
			const position = $(urlHash).offset().top - headerHeight -30;
			$('html, body').animate({scrollTop: position}, speed, 'swing');
		}
	});

	// 施工実績 セレクトボックス文字入れ替え処理（safari対策）
	$('.works-sort_select').on('change', function() {
		const $option = $(this).find('option:selected');
		$(this).prev('.works-sort_label').text($option.text());
	});

	// 施工実績（松竹工業の技術）スライドショー
	// トップページ用
	const top_common_slide = new Swiper('body.home .common-slider_slide', {
		loop: true,
		speed: 500,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		navigation: {
			nextEl: '.common-slider_button-next',
			prevEl: '.common-slider_button-prev'
		},
		slidesPerView: 1,
		spaceBetween: 36.5,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 40,
			}
		},
	});
	// 下層ページ用
	const lower_common_slide = new Swiper('.lower-page_contents .common-slider_slide', {
		loop: true,
		speed: 500,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		navigation: {
			nextEl: '.common-slider_button-next',
			prevEl: '.common-slider_button-prev'
		},
		slidesPerView: 1,
		spaceBetween: 36.5,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 33,
			}
		},
	});

	// 事業内容ページ 各工事スライドショー
	const construction_detail_slide = new Swiper('.construction-detail_slide', {
		loop: true,
		speed: 500,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		slidesPerView: 1,
		spaceBetween: 36.5,
	});

	// 採用ページ スライドショー
	const recruit_interview_slide = new Swiper('.recruit-interview_image-slide', {
		loop: true,
		speed: 500,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		slidesPerView: 1,
		spaceBetween: 36.5,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 48,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	});
});